import type { ReactNode } from "react";
import { Link } from "wouter";
import { Lock } from "lucide-react";
import { useFormationGuard } from "@/hooks/useFormationGuard";
import type { Parcours } from "@/lib/formationApi";

const GOLD = "oklch(0.695 0.105 68)";
const BORDER = "color-mix(in oklch, oklch(0.695 0.105 68) 18%, transparent)";

/**
 * Verrou d'accès aux fonctionnalités sensibles, conditionné à la certification
 * du parcours (AVOCAT par défaut, ARBITRE pour le cockpit arbitre). Inerte tant
 * que `FORMATION_GATING_ACTIVE` est `false`.
 */
export function FormationGate({
  feature,
  parcours = "AVOCAT",
  children,
}: {
  feature: string;
  parcours?: Parcours;
  children: ReactNode;
}) {
  const { canAccessFeature, loading } = useFormationGuard(parcours);

  if (loading || canAccessFeature(feature)) return <>{children}</>;

  const lien = parcours === "ARBITRE" ? "/formation-arbitre" : "/formation";
  return (
    <div
      className="rounded-md border p-4 text-center space-y-2"
      style={{ borderColor: BORDER }}
    >
      <div className="flex items-center justify-center gap-2 text-sm" style={{ color: GOLD }}>
        <Lock size={15} /> Accès réservé aux utilisateurs certifiés
      </div>
      <p className="text-xs" style={{ opacity: 0.7 }}>
        Cette fonctionnalité nécessite la certification « GSF Arbitral AI ».
      </p>
      <Link
        href={lien}
        className="inline-block rounded-md px-3 py-1.5 text-sm font-medium"
        style={{ background: GOLD, color: "oklch(0.18 0.02 243)" }}
      >
        Commencer la formation
      </Link>
    </div>
  );
}
